import { useState } from 'react';
import { postApi } from './ProxyUtils';

export const useVmAddresses = (idLab, labType) => {
    const [vmList, setVmList] = useState([]);
    const [loadingVm, setLoadingVm] = useState(false);
    const [vmError, setVmError] = useState(null);

    const getToken = async () => {
        const tokenUrl = process.env.REACT_APP_URL_ELEARNING_TOKEN;
        if (!tokenUrl) return null;

        const response = await fetch(tokenUrl, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' }
        });

        if (!response.ok) {
            throw new Error(`Errore nel recupero del token: HTTP ${response.status}`);
        }

        const tokenData = await response.json();
        if (tokenData.status !== 'SUCCESS' || !tokenData.access_token) {
            throw new Error('Token non valido ricevuto dal server');
        }

        return tokenData.access_token;
    };

    const loadVmList = async (signal) => {
        if (!idLab) return;
        setLoadingVm(true);
        setVmError(null);

        try {
            const vmCharUrl = process.env.REACT_APP_URL_VM_CHARACTERISTICS;

            if (!vmCharUrl) {
                // MOCK
                console.log("DEBUG: Caricamento VM (MOCK)");
                setVmList([
                    { dns_name: 'vm-lab-01', agent_ipv4_address: '10.0.1.10', name: 'vm-01' },
                    { dns_name: 'vm-lab-02', agent_ipv4_address: '10.0.1.11', name: 'vm-02' },
                    { dns_name: 'vm-lab-03', agent_ipv4_address: null, name: 'vm-03' }
                ].filter(vm => vm.agent_ipv4_address));
                return;
            }

            const token = await getToken();
            if (!token) {
                throw new Error('Impossibile ottenere il token');
            }

            const response = await fetch(vmCharUrl, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ idLab: String(idLab), labType }),
                signal
            });

            if (!response.ok) {
                throw new Error(`Errore HTTP ${response.status}`);
            }

            const result = await response.json();

            if (result.statusRequest === 'success' && result.data?.result) {
                const poweredOnVms = result.data.result.filter(vm => vm.agent_ipv4_address);
                setVmList(poweredOnVms);
            } else {
                throw new Error(result.status || 'Errore nel recupero dei dati VM');
            }
        } catch (err) {
            if (err.name === 'AbortError') return;
            console.error("Errore nel caricamento VM:", err);
            setVmError(err.message);
            setVmList([]);
        } finally {
            setLoadingVm(false);
        }
    };

    const sendAddresses = async (addresses) => {
        if (!idLab) throw new Error('ID laboratorio non trovato');

        const ips = addresses || vmList.map(vm => vm.agent_ipv4_address).filter(Boolean);
        if (ips.length === 0) {
            console.log("DEBUG: Nessun IP VM da inviare");
            return null;
        }

        return postApi('REACT_APP_URL_PROXY_SEND_VM_ADDRESSES', {
            idLab,
            addresses: ips
        }, {
            mock: async () => {
                await new Promise(r => setTimeout(r, 500));
                console.log("DEBUG: Invio VM addresses (MOCK)", ips);
                return { statusRequest: 'success' };
            }
        });
    };

    const vmIpAddresses = vmList.map(vm => vm.agent_ipv4_address).filter(Boolean);

    return { vmList, vmIpAddresses, loadingVm, vmError, loadVmList, sendAddresses };
};
